import { Brand, createBranded } from '@deltasierra/type-utilities';

export type TemplateContentBuildLocationId = Brand<number, 'TemplateContentBuildLocationId'>;
export const TemplateContentBuildLocationId = createBranded<TemplateContentBuildLocationId>();
